import { Blueprint } from '@/src/@types/infrastructur'
import * as Flch from '@/src/blueprints/Flch'
import * as Magazine from '@/src/blueprints/Magazine'
import * as Pages from '@/src/blueprints/Pages'
import * as Partners from '@/src/blueprints/Partners'

const blueprints: Record<string, Blueprint<any>> = {
  pages: Pages,
  blink_magazine: Magazine,
  nohe_magazine: Magazine,
  blink_partners: Partners,
  flch: Flch,
}

export default function find<Name extends string>(blueprintName: Name) {
  const blueprint = blueprints[blueprintName]

  if (!blueprint) {
    return undefined
  }

  return { ...blueprint, name: blueprintName }
}
